<template>
  <div class="chart-legend">
    <div
      v-for="(item, index) in legendItems"
      :key="index"
      class="legend-item"
    >
      <span
        class="legend-color"
        :style="{ backgroundColor: item.color }"
      />
      <slot :item="item" name="legend-label">
        <div v-if="Array.isArray(item.label)" class="d-flex flex-column align-items-start justify-content-start">
          <span
            v-for="label in item.label"
            :key="label"
            class="new-legend-text"
          >
            {{ label }}
          </span>
        </div>
        <span v-else class="new-legend-text">{{ item.label }}</span>
      </slot>
    </div>
  </div>
</template>

<script setup>
defineProps({
  legendItems: {
    type: Array,
    default: () => [],
  },
  justifyContent: {
    type: String,
    default: 'center',
  },
});
</script>

<style scoped lang="less">
.chart-legend {
  display: flex;
  flex-direction: column;
  justify-content: v-bind(justifyContent);
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 4px;
}

.legend-color {
  width: 12px;
  height: 12px;
  min-width: 12px;
  min-height: 12px;
  border-radius: 50%;
}
</style>
